/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The satisfaction status of a constraint.
 */
export var ConstraintSatisfaction;
(function (ConstraintSatisfaction) {
    ConstraintSatisfaction["SATISFIED"] = "Satisfied";
    ConstraintSatisfaction["UNSATISFIED"] = "Unsatisfied";
    ConstraintSatisfaction["UNKNOWN"] = "Unknown";
})(ConstraintSatisfaction || (ConstraintSatisfaction = {}));
